<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
        </div>
        <register-component></register-component>
    </section>
</template>
<script>
import Modal from "@/components/Modal.vue";
import RegisterComponent from "@/layout/components/Auth/RegisterComponent";

import { mapActions, mapState } from 'vuex';

export default {
    components: { Modal, RegisterComponent },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if ( vm.$store.state.modal.showModal == true ) {
                vm.$store.commit('modal/toggleModal');
            }
        })
    }
};
</script>
